// import Footer from './Footer';
// import UserMarket from '../UserMarket';
import { isRoundedPlatform } from '@/helpers/environmentHelper';
import { useDisclosure } from '@/utils/hooks/useDisclosure';
import useScreenSizes from '@/utils/hooks/useScreenSizes';
import cn from 'classnames';
import { useMemo, useState } from 'react';
import Navbar from '../Navbar';
import UniversalSidebar from '../UniversalSidebar';

interface LiteLayoutProps extends React.PropsWithChildren {}

export default function LiteLayout({ children }: LiteLayoutProps) {
    const settings = useDisclosure(false);
    const { mobile, tablet } = useScreenSizes();

    const [isExpanded, setIsExpanded] = useState(true);

    const isMobile = useMemo(() => mobile || tablet, [mobile, tablet]);

    const width = useMemo(() => {
        if (isMobile) {
            return '100%';
        } else {
            return isExpanded ? 'calc(100% - 257px)' : 'calc(100% - 61px)';
        }
    }, [isExpanded, isMobile]);

    const marginLeft = useMemo(() => {
        if (isMobile) {
            return 0;
        } else {
            return isExpanded ? 257 : 61;
        }
    }, [isExpanded, isMobile]);

    return (
        <div className="flex h-full">
            <UniversalSidebar
                isExpanded={isExpanded}
                setIsExpanded={setIsExpanded}
                settingsDisclosure={settings}
                isAlwaysExpanded
            />
            <div
                className={cn('flex flex-col h-full', {
                    'transition-all duration-200': !isMobile
                })}
                style={{ width, marginLeft }}>
                <Navbar settings={settings} />
                <main className={cn('h-full overflow-y-auto', { 'bg-brand-background': !isRoundedPlatform })}>
                    {children}
                </main>
            </div>
        </div>
    );
}
